import { Block } from '../../../../../types/shared/blocks';

export const calculateCanvasBounds = (
	blocks: Block[],
	scaleFactor: number
): { width: number; height: number; offsetX: number; offsetY: number } => {
	// Use large canvas size matching grid size (viewport * 3)
	const viewportWidth = window.innerWidth;
	const viewportHeight = window.innerHeight;
	const canvasWidth = Math.max(viewportWidth * 3, 3000);
	const canvasHeight = Math.max(viewportHeight * 3, 3000);

	if (!blocks || blocks.length === 0) {
		return {
			width: canvasWidth,
			height: canvasHeight,
			offsetX: 0,
			offsetY: 0,
		};
	}

	let minX = Infinity;
	let minY = Infinity;
	let maxX = -Infinity;
	let maxY = -Infinity;

	const processBlock = (block: Block) => {
		if (!block.position) return;

		const blockWidth = block.displayDimensions.width * scaleFactor;
		const blockHeight = block.displayDimensions.height * scaleFactor;

		const x = block.position.x;
		const y = block.position.y;

		minX = Math.min(minX, x);
		minY = Math.min(minY, y);
		maxX = Math.max(maxX, x + blockWidth);
		maxY = Math.max(maxY, y + blockHeight);
	};

	blocks.forEach((block) => {
		processBlock(block);

		if (block.stairs) {
			block.stairs.forEach(processBlock);
		}
		if (block.landings) {
			block.landings.forEach(processBlock);
		}
		if (block.bumpouts) {
			block.bumpouts.forEach(processBlock);
		}
	});

	if (minX === Infinity || minY === Infinity) {
		return {
			width: canvasWidth,
			height: canvasHeight,
			offsetX: 0,
			offsetY: 0,
		};
	}

	// Use large canvas size to allow free movement across entire grid
	const width = canvasWidth;
	const height = canvasHeight;

	// No offset - blocks should render at their exact positions
	// Grid lines start at 0, so block position should match grid position
	const offsetX = 0;
	const offsetY = 0;

	return {
		width,
		height,
		offsetX,
		offsetY,
	};
};
